import { DriveCardShell, DriveCardAction } from './drive_card_shell.component';
import { FileTypeIcon } from './file_type_icon.component';
import { CommonDocumentService } from '@umanforge/common';


interface FileCardProps {
  name: string;
  /** Extension sans le point */
  extension: string;
  /** Taille fournie par l'API en kilo-octets (Ko) */
  sizeBytes: number;
  lastModified?: Date | string;
  actions?: DriveCardAction[];
  onClick?: () => void;
}

function formatSize( kilo: number ): string {
  if ( kilo == null || kilo < 0 ) { return '—'; }
  return CommonDocumentService.getReadableFileSizeString( kilo );
}

export function FileCard( { name, extension, sizeBytes, lastModified, actions, onClick }: FileCardProps ) {
  return (
    <DriveCardShell
      icon={
        <FileTypeIcon
          extension={ extension }
          className="w-14 h-16"
        />
      }
      name={ name }
      subtitle={ formatSize( sizeBytes ) }
      lastModified={ lastModified }
      actions={ actions }
      onClick={ onClick }
    />
  );
}
